import ReactPixel from "react-facebook-pixel";

const options = {
    autoConfig: false,
    debug: true
};

const advancedMatching = {
    em: undefined,
    ph: undefined,
};

export function initFacebookPixel() {
    try {
        const pixelId = '325830968618472';
        ReactPixel.init(pixelId, advancedMatching, options);
        ReactPixel.pageView();
        console.log('Facebook Pixel initialized successfully with options:', options);
    } catch (error) {
        console.error('Error initializing Facebook Pixel:', error);
    }
} 